<template>
    <div class="user-config">
        <div class="item">
            <div class="label">加我为好友时需要验证</div>
            <el-switch v-model="userInfo.isManualApprove" @change="onManualApproveChange"></el-switch>
        </div>
        <div class="item">
            <div class="label">新消息提示音</div>
            <el-switch v-model="userInfo.isAudioTip" @change="onMessageAudioTip"></el-switch>
        </div>
    </div>
</template>
<script>
export default {
    name: "userConfig",
    data() {
        return {
            userInfo: {
                isManualApprove: false,
                isAudioTip: false
            }
        }
    },
    methods: {
        init() {
            let mine = this.userStore.userInfo;
            this.userInfo = JSON.parse(JSON.stringify(mine));
        },
        onManualApproveChange() {
            this.$http({
                url: "/user/manualApprove?enabled=" + this.userInfo.isManualApprove,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        },
        onMessageAudioTip() {
             this.$http({
                url: "/user/audioTip?enabled=" + this.userInfo.isAudioTip,
                method: 'put'
            }).then(() => {
                this.userStore.loadUser();
            })
        }
    }
}
</script>
<style scoped lang="scss">
.user-config {
    padding: 20px;

    .item {
        display: flex;
        padding: 5px;

        .label {
            width: 200px;
        }
    }
}
</style>
